import React, { useEffect, useState } from "react";
import { Dialog, IconButton, CircularProgress } from "@mui/material";
import { ReactComponent as DeleteIcon } from "assets/img/svg/Delete.svg";
import { ReactComponent as CloseIcon } from "assets/img/svg/CrossIcon.svg";

import { Document, Page } from "react-pdf";
import { fetchAllPostPromisedData } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import { endpoint } from "views/pages/manage/common/constant";

const DocumentViewer = ({
  open,
  onClose,
  s3Key, // <-- Parent will pass ONLY s3Key
  title = "Document",
  showDelete = false,
  onDelete = () => {},
}) => {
  const [fileUrl, setFileUrl] = useState("");
  const [numPages, setNumPages] = useState(null);
  const [loading, setLoading] = useState(false);
  const [imageFailed, setImageFailed] = useState(false);

  // Fetch S3 download URL using s3Key
  const fetchFileUrl = async () => {
    if (!s3Key) return;

    setLoading(true);

    const response = await fetchAllPostPromisedData(
      `${endpoint.fetchS3Url.getDownloadUrl}?key=${s3Key}`,
      true
    );

    if (response.code === 200 && response.data?.url) {
      setFileUrl(response.data.url);
    }

    setLoading(false);
  };

  useEffect(() => {
    if (open) fetchFileUrl();
  }, [open, s3Key]);

  const isImage = () => {
    debugger
    if (!fileUrl) return false;
    console.log("fileUrl",fileUrl)
    const ext = fileUrl.split("?")[0].split(".").pop().toLowerCase();
    return true;
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="lg"
      PaperProps={{
        style: {
          padding: "0px",
          borderRadius: "12px",
          background: "#fff",
          overflow: "hidden",
        },
      }}
    >
      {/* HEADER */}
      <div
        style={{
          padding: "18px 24px",
          borderBottom: "1px solid #E5E5E5",
          fontSize: "20px",
          fontWeight: 600,
          color: "#262626",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        {title}
        <IconButton onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </div>

      {/* CONTENT */}
      <div
        style={{
          padding: "20px",
          display: "flex",
          justifyContent: "center",
          alignItems: "flex-start", // ✅ KEY FIX
          maxHeight: "85vh",
          overflowY: "auto",
        }}
      >
        {loading ? (
          <CircularProgress />
        ) : (
          <>
            {/* IMAGE VIEW */}
            {fileUrl && !imageFailed && (
              <img
                src={fileUrl}
                alt="Document"
                onError={() => setImageFailed(true)}
                style={{
                  maxWidth: "90vw",
                  maxHeight: "80vh",
                  objectFit: "contain",
                  border: "5px solid #2D9CDB",
                  borderRadius: "6px",
                }}
              />
            )}

            {/* PDF VIEW */}
            {fileUrl && imageFailed && (
              <Document
                file={fileUrl}
                onLoadSuccess={(d) => setNumPages(d.numPages)}
                loading={<CircularProgress />}
              >
                {Array.from(new Array(numPages), (el, i) => (
                  <Page
                    key={`p_${i}`}
                    pageNumber={i + 1}
                    width={1100}
                    renderTextLayer={false}
                    renderAnnotationLayer={false}
                    style={{ marginTop: i === 0 ? 10 : 0 }} // ✅ safety
                  />
                ))}
              </Document>
            )}
          </>
        )}
      </div>

      {/* FOOTER DELETE BUTTON */}
      {showDelete && (
        <div
          style={{
            padding: "12px 20px",
            borderTop: "1px solid #F0F0F0",
            display: "flex",
            justifyContent: "flex-start",
          }}
        >
          <IconButton
            onClick={onDelete}
            size="small"
            style={{ color: "#D9534F" }}
          >
            <DeleteIcon fontSize="medium" />
          </IconButton>
        </div>
      )}
    </Dialog>
  );
};

export default DocumentViewer;
